import {api} from '../../contexts/AuthContext';

// Equativ Sync API
export const equativSyncApi = {
    exportTaxonomy: async (type: 'eskimi_only' | 'public', environment: string = 'production', delimiter: string = '|'): Promise<void> => {
        const response = await api.post('/api/equativ-sync/export/taxonomy', { environment, type, delimiter }, {
            responseType: 'blob',
        });
        const blob = new Blob([response.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const disposition = response.headers['content-disposition'];
        const filename = disposition?.match(/filename="(.+)"/)?.[1] || `equativ_taxonomy_${type}.csv`;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    },
};
